import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import theme from './theme';
import { store } from './store';
import AppRoutes from './routes/AppRoutes';
import { useCommonSlice } from './store/slices/common';

function AppProviders({ children }: { children: React.ReactNode }) {
  useCommonSlice();
  return <>{children}</>;
}

function App() {
  return (
    <Provider store={store}>
      <AppProviders>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ThemeProvider>
      </AppProviders>
    </Provider>
  );
}

export default App;
